import { render, staticRenderFns } from "./CollectionGroupHost.vue?vue&type=template&id=3de6298d"
import script from "./CollectionGroupHost.vue?vue&type=script&lang=js"
export * from "./CollectionGroupHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports